var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "loading-overlay" },
    [
      _c("b-spinner", {
        class: { size: _vm.size === "large" },
        attrs: { variant: _vm.theme }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }